import * as THREE from 'three';
import { logger } from '../utils/logger';

interface TargetPose {
  position: { x: number; y: number; z: number };
  rotation: { x: number; y: number; z: number; w: number };
  scale?: number;
  scaledWidth?: number;
  scaledHeight?: number;
}

let overlayMesh: THREE.Mesh | null = null;

export function addPosterOverlay(scene: THREE.Scene): void {
  if (overlayMesh) return;

  const texture = new THREE.TextureLoader().load('/assets/poster_overlay.jpg', () => {
    logger.log('Poster overlay texture loaded');
  });

  const geometry = new THREE.PlaneGeometry(1, 1);
  const material = new THREE.MeshBasicMaterial({ map: texture });

  overlayMesh = new THREE.Mesh(geometry, material);
  overlayMesh.name = 'poster-overlay';
  overlayMesh.visible = false;
  overlayMesh.frustumCulled = false;
  scene.add(overlayMesh);
  logger.log('Poster overlay mesh added to scene');
}

/**
 * Snaps the overlay plane to the image target pose. Called on imagefound and
 * imageupdated so the plane tracks the sign while it is in frame.
 */
export function updatePosterOverlay(pose: TargetPose): void {
  if (!overlayMesh) return;

  overlayMesh.position.set(pose.position.x, pose.position.y, pose.position.z);
  overlayMesh.quaternion.set(
    pose.rotation.x,
    pose.rotation.y,
    pose.rotation.z,
    pose.rotation.w,
  );

  // scale = largest dimension in world units.
  // scaledWidth / scaledHeight are the width and height fractions of scale.
  const s = pose.scale ?? 1;
  overlayMesh.scale.set(
    s * (pose.scaledWidth ?? 1),
    s * (pose.scaledHeight ?? 1),
    1,
  );
  overlayMesh.visible = true;
}

export function hidePosterOverlay(): void {
  if (overlayMesh) overlayMesh.visible = false;
}
